
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '@/components/HeaderUpdated';
import ShopProducts from '@/components/shop/ShopProducts';
import AppPromo from '@/components/AppPromo';
import Brands from '@/components/Brands';
import Footer from '@/components/Footer';
import ProductSidebar from '@/components/shop/ProductSidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLanguage } from '@/contexts/LanguageContext';

const Shop = () => {
  const { t } = useLanguage();
  const [searchParams, setSearchParams] = useSearchParams();
  const [categoryId, setCategoryId] = useState<string | null>(searchParams.get('category'));
  const [subcategoryId, setSubcategoryId] = useState<string | null>(searchParams.get('subcategory'));
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobile = useIsMobile();

  // Sync with URL params when they change
  useEffect(() => {
    setCategoryId(searchParams.get('category'));
    setSubcategoryId(searchParams.get('subcategory'));
  }, [searchParams]);

  const handleCategorySelect = (id: string | null) => {
    setCategoryId(id);
    setSubcategoryId(null); // Reset subcategory when changing category
    
    // Atualizar URL
    if (id) {
      searchParams.set('category', id);
      searchParams.delete('subcategory');
    } else {
      searchParams.delete('category');
      searchParams.delete('subcategory');
    }
    setSearchParams(searchParams);
    
    // Close sidebar on mobile after selection
    if (isMobile) {
      setShowSidebar(false);
    }
  };


  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className="min-h-screen bg-[#1b1b1b]">
      <Header />
      <main className="pt-4">
        {isMobile && (
          <div className="container mx-auto px-4 mb-4">
            <button 
              onClick={toggleSidebar} 
              className="w-full py-2 bg-brand-red text-white rounded-md flex items-center justify-center"
            >
              {showSidebar ? t('products.hideFilters') : t('products.showFilters')}
            </button>
          </div>
        )}
        <div className="container mx-auto px-4 py-4 lg:py-12">
          <div className={`grid grid-cols-1 lg:grid-cols-[16rem_1fr] gap-8 relative`}>
            <div className={`${isMobile ? (showSidebar ? 'block' : 'hidden') : 'block'}`}>
              <ProductSidebar
                selectedCategory={categoryId}
                onCategorySelect={handleCategorySelect}
              />
            </div>
            <div className={`${isMobile && showSidebar ? 'hidden' : 'block'}`}>
              <ShopProducts
                categoryId={categoryId}
                subcategoryId={subcategoryId}
              />
            </div>
          </div>
        </div>
        <AppPromo />
        <Brands />
      </main>
      <Footer />
    </div>
  );
};

export default Shop;
